import casting_calls_services from "@/services/casting_calls";

export const castingCallsRepository = {
  async getCastingCalls(limit = 8) {
    const res = await casting_calls_services.getCastingCalls({}, limit);
    return res?.results ?? [];
  },
};